import React from 'react';
import {Navbar} from 'react-bootstrap';
import { SocialIcon } from 'react-social-icons';


export function Footer()
{
  return(
    <>
    <Navbar id = "footerStrip" sticky="bottom" headerMode = "none">
      <div class="nav navbar-nav mx-auto">
        <SocialIcon bgColor="#191919" url="https://twitter.com/ConradicalGames" style={{ height: 30, width: 30 }}/>
        <SocialIcon bgColor="#191919" url="https://www.youtube.com/channel/UC3SUzBUNbS95AaLyW6lD8Pg" style={{ height: 30, width: 30 }}/>
        <SocialIcon bgColor="#191919" url="https://www.instagram.com/conradicalgames/" style={{ height: 30, width: 30 }}/>
      </div>




      </Navbar>
      <br></br>
      </>

  )
}

export default Footer;
